import { render, staticRenderFns } from "./ShowConference.vue?vue&type=template&id=3ccc2172"
import script from "./ShowConference.vue?vue&type=script&lang=js"
export * from "./ShowConference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports